import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

function ExchangesTable({ getFieldValue, lineItems, setFieldValue }) {
  const FIELD = "purchase_order_line_item_id";

  const renderRow = (lineItem, i) => (
    <tr key={i}>
      <td>{i + 1}</td>
      <td>
        <Field
          component="input"
          type="radio"
          checked={String(lineItem.id) === getFieldValue(FIELD)}
          onChange={() => setFieldValue(FIELD)(lineItem.id)}
          name={FIELD}
          className="radio-inline"
          value={lineItem.id}
        />
      </td>
      <td>{lineItem.part.part_number}</td>
      <td>{lineItem.purchase_order.code}</td>
      <td>{lineItem.serial_number}</td>
    </tr>
  );

  return (
    <table className="table table-striped table-hover table-numbered">
      <thead>
        <tr>
          <th />
          <th />
          <th>Part #</th>
          <th>Code</th>
          <th>Serial Number</th>
        </tr>
      </thead>
      <tbody>{lineItems.map(renderRow)}</tbody>
    </table>
  );
}

ExchangesTable.propTypes = {
  filter: PropTypes.shape({}),
  lineItems: PropTypes.arrayOf(PropTypes.shape({})),
  getFieldValue: PropTypes.func.isRequired,
  selectedLineItem: PropTypes.shape({}),
  setFieldValue: PropTypes.func.isRequired
};

export default withFieldAccessors(ExchangesTable);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/AssignToExchange/ExchangesTable.jsx